import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { EMPTY_ARRAY } from '../../constants/globalConstants'
// import play from '../../assets/img/play.png'
// import ios from '../../assets/img/ios.png'
import appstore from '../../assets/img/appstore.png'
import playstore from '../../assets/img/playstore.png'
import URL from '../../constants/urls'
import { getMobileOS } from '../../utils/helper'

function DownloadApp() {
    const [isDisplayDownload,setIsDisplayDownload] = useState(false)
    // const [isExpanded,setIsExpanded] = useState(false)
    const [os, setOs] = useState('Other')
    
    useEffect(() => {
        // setIsExpanded(false)
        if(!localStorage.getItem('isDownload')){
        localStorage.setItem('isDownload', true)
        setIsDisplayDownload(true)
        }else{
            // const isDownload = localStorage.getItem('isDownload')
            setIsDisplayDownload(true)
        }
        const os = getMobileOS()
        setOs(os)
    },[EMPTY_ARRAY])

    const handleHideDownload = () => {
        localStorage.setItem('isDownload', false)
        setIsDisplayDownload(false)
    }

    // const handleExpand = () => {
    //     setIsExpanded(true)
        
    // }

    return (
        isDisplayDownload && <div className='zIndex styleLables position-fixed bottom-0 bg-black w-100 text-white p-2 '>
            <i className="fa fa-close text-white position-absolute end-0 iconClose" onClick={() => handleHideDownload()}></i>
            <div className='p-2 g-0 row justify-content-between align-items-center'>
                <div className='col-8'>Save time and download the app</div>
                <div className='col text-end'>
                        {(os == 'Android' || os == 'Other') && <a className={os == 'Other' ? 'me-4' : ''} href={URL?.ANDROID_URL} rel='noreferrer' target="_blank">
                            <img height={'40px'} src={playstore} alt='Play Store'/>
                        </a>}
                        {(os == 'iOS' || os == 'Other') && <a href={URL?.IOS_URL} rel='noreferrer' target="_blank">
                            <img height={'40px'} src={appstore} alt='Play Store'/>
                        </a>}
                    </div>
            </div>
            
        </div>
    )
}

DownloadApp.propTypes = {
    dispatch: PropTypes.func,
}

DownloadApp.defaulProps = {
    dispatch: noop,
}


export default DownloadApp